"use client";
import { useEffect } from "react";

export const LazyFontLoader = () => {
  useEffect(() => {
    const loadFontsWhenIdle = () => {
      if ("requestIdleCallback" in window) {
        requestIdleCallback(() => {
          loadFonts();
        });
      } else {
        // 降级方案
        setTimeout(loadFonts, 2000);
      }
    };

    const loadFonts = () => {
      const fontWeights = [
        { weight: 400, file: "AlibabaPuHuiTi-3-55-Regular.ttf" },
        { weight: 700, file: "AlibabaPuHuiTi-3-85-Bold.ttf" },
      ];

      fontWeights.forEach(({ weight, file }) => {
        const link = document.createElement("link");
        link.rel = "preload";
        link.href = `/fonts/${file}`;
        link.as = "font";
        link.type = "font/ttf";
        link.crossOrigin = "anonymous";
        document.head.appendChild(link);
      });
    };

    loadFontsWhenIdle();
  }, []);

  return null;
};
